<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit">
      <div class="table-body">
        <div style="overflow: hidden; margin: 0 0 8px 0">
          <div class="left">推荐奖励配置</div>
          <div class="right"></div>
        </div>
        <el-table
          id="outTable"
          border
          :data="tableData"
          style="width: 100%"
          lazy
        >
          <el-table-column label="项目" prop="rewardItem" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.rewardItem }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否启用" prop="isEnable" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.isEnable == "1" ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="提成模式" prop="rewardMode" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.rewardMode == "01" ? "固定金额" : "比例"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="固定金额" prop="fix" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fix }}元</span>
            </template>
          </el-table-column>
          <el-table-column label="按比例" prop="ratio" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ratio * 100 }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="oper" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleShowDialog(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      width="50%"
      :visible.sync="noteDialogVisible"
      class="note-dialog"
    >
      <el-row>
        <el-col>
          <el-form
            ref="form"
            :model="form"
            label-position="left"
            label-width="100px"
          >
            <el-form-item prop="vipType" label="项目">
              {{ form.rewardItem }}
            </el-form-item>
            <el-form-item prop="fix" label="固定金额" required>
              <el-input
                v-model="form.fix"
                placeholder="请输入固定金额"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="ratio" label="按比例" required>
              <el-input
                v-model="form.ratio"
                placeholder="请输入比例"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="rewardMode" label="提成模式" required>
              <el-radio-group
                v-model="form.rewardMode"
                size="small"
              >
                <el-radio label="01">固定金额</el-radio>
                <el-radio label="02">按比例</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="isEnable" label="是否启用" required>
              <el-radio-group
                v-model="form.isEnable"
                size="small"
              >
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave" size="small"
          >确 定</el-button
        >
        <el-button @click="noteDialogVisible = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"

import { getRewardList, editReward } from "@/api/mine/reward"

export default {
  name: "inviteManage",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      noteDialogVisible: false,
      noteDialogAddVisible: false,
      form: {
        rewardItem: "",
        rewardMode: "",
        fix: "",
        ratio: "",
        isEnable: "",
      },
      total: 0,
      loading: false,
      tableData: [],
      dialogTitle: "",
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.startLoading()
      let params = {}
      getRewardList(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.rows
          this.endLoading()
        })
        .catch((err) => {
          this.endLoading()
          console.error(err)
        })
    },
    handleShowDialog(data) {
      this.form = this._.clone(data)
      this.noteDialogVisible = true
    },
    handleSave() {
      let _self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          editReward(_self.form).then((response) => {
            if (response.code == "200") {
              _self.msgSuccess("修改成功！")
              _self.noteDialogVisible = false
              _self.loadData()
            } else {
              _self.msgError("修改失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style scoped></style>
